// extracted by mini-css-extract-plugin
export default {"value":"PileParametersSection_value__SjnVV","wrapper":"PileParametersSection_wrapper__GAne9"};